var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-174 -95)"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M10.435 12.508H13.565000000000001V23.985999999999997H10.435zM1.043 23.464c0 .29.233.522.522.522h7.826V12.507H1.043v10.957zM14.609 23.986h7.826c.288 0 .522-.233.522-.522V12.508h-8.348v11.478zM23.478 6.247h-7.344c.651-.331 1.28-.738 1.788-1.245.555-.554.86-1.292.86-2.078 0-.784-.305-1.522-.86-2.076-1.11-1.112-3.044-1.112-4.155 0-.818.817-1.396 1.94-1.767 2.987-.373-1.046-.949-2.17-1.768-2.987-1.11-1.112-3.046-1.112-4.154 0-.555.554-.86 1.292-.86 2.076 0 .786.305 1.524.86 2.078.507.507 1.137.914 1.788 1.245H.522c-.29 0-.522.233-.522.521v4.174c0 .29.233.522.522.522h8.87v-4.59c.367.117.723.217 1.043.282v4.308h3.13V7.156c.318-.065.675-.165 1.044-.282v4.59h8.87c.287 0 .521-.233.521-.522V6.768c0-.288-.234-.521-.522-.521zm-11.998 0h-.058c-.847-.03-3.282-.658-4.606-1.983-.359-.358-.555-.834-.555-1.34 0-.506.196-.982.555-1.339.358-.359.834-.556 1.339-.556.507 0 .983.197 1.34.556 1.343 1.342 1.973 3.831 1.986 4.646v.016zm1.097 0h-.057l-.001-.016c.013-.815.642-3.304 1.985-4.646.358-.359.834-.556 1.34-.556.506 0 .982.197 1.34.556.358.357.555.833.555 1.34 0 .505-.197.981-.555 1.34-1.324 1.324-3.759 1.952-4.607 1.982z",
      "transform": "translate(174 95)"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }